<sub-header [isModal]="true" [windowHash]=windowHash [includeContextHelp]="true"></sub-header>
<p-scrollPanel [style]="{width: '100%', height: '95vh'}" styleClass="custombar1">
  <div class="container-fluid ">
    <ng-container *ngIf="isLoaded()">
      <!-- MOTRAMOS LA CABECERA DEL CONTRATO -->
      <ng-container *ngTemplateOutlet="contractInfo"></ng-container>
      <div class="row m-t-md ">
        <div class="col-12 ">
          <p-panel styleClass="mb-3" [toggleable]="TRUE">
            <p-header><i class="fas fa-history"></i> Antecedentes </p-header>
            <div class="row m-t-md ">
              <div class="col-12 ">
                <formPlyca #formPlycaRef1 [formConfig]="formConfig1" *ngIf="formConfig1" [manageWaitService]=false>
                </formPlyca>
              </div>
            </div>
            <!-- A CONTINUACION, EL TEMPLATE CON LA TABLA DE ANTECEDENTES DE LA INCIDENCIA -->
            <div class="row m-t-md ">
              <div class="col-12 ">
                <p-tabView>
                  <p-tabPanel *ngIf="antecedents && antecedents.filterContractModificationAntecedents &&
                  antecedents.filterContractModificationAntecedents.length > 0" cache="false" header="{{'Antecedentes de la Incidencia' | translate}}">
                    <ng-container *ngTemplateOutlet="contractModificationAntecedentTableTemplate"></ng-container>
                  </p-tabPanel>
                  <p-tabPanel cache="false" header="{{'Estado actual del contrato' | translate}}">
                    <ng-container *ngTemplateOutlet="contractAntecedentTableTemplate"></ng-container>
                  </p-tabPanel>
                  <p-tabPanel *ngIf="antecedents && antecedents.withPriceRevision" cache="false"
                    header="{{'Incidencias de Revisión de Precios Sin Gasto' | translate}}">
                    <ng-container *ngTemplateOutlet="antecedentPriceRevisionTableTemplate"></ng-container>
                  </p-tabPanel>
                </p-tabView>
              </div>
            </div>
          </p-panel>
        </div>
      </div>
      <!--<ng-container *ngTemplateOutlet="antecedentTableTemplate"></ng-container>
      <ng-container *ngTemplateOutlet="antecedentPriceRevisionTableTemplate"></ng-container> -->
    </ng-container>
  </div>
</p-scrollPanel>


<ng-template #contractInfo>
  <ng-container *ngIf="contract">
    <contractHeader [contract]="contract"></contractHeader>
  </ng-container>
</ng-template>

<ng-template #contractAntecedentTableTemplate>
  <div class="row m-t-md ">
    <div class="col-12 ">
      <div class="row  ">
        <div class="col-12 ">

          <ng-container *ngIf="!antecedents || !antecedents.filterContractAntecedents
          || antecedents.filterContractAntecedents.length === 0; else dataExists">
            <div class="alert alert-info col-12" role="alert">
              <span style="line-height: 2em;">
                <i class="fa fa-1-5x fa-info-circle mr-2" aria-hidden="true"></i>
                {{ 'General.noData' | translate }}
              </span>
            </div>
          </ng-container>
          <ng-template #dataExists>
            <p-table [value]="antecedents.filterContractAntecedents" [responsive]="false" class="col-12"
              dataKey="identifier" editMode="row">
              <!-- Contenido de la tabla -->

              <ng-template pTemplate="header">
                <tr>
                  <th [style.width]="'20%'">{{'Incidencia'|translate}}</th>
                  <th [style.width]="'30%'">{{'Fecha Aprobación'| translate}}</th>
                  <th class="text-right" *ngIf="!frameworkAgreement">{{'Presupuesto
                    (+IVA)'|translate}}</th>
                  <th class="text-right" *ngIf="!frameworkAgreement">{{'Precio (+IVA)'|
                    translate}}</th>
                  <th class="text-right">{{'Plazo (Meses)'| translate}}</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-antecedent>
                <tr>
                  <td><span class="p-column-title">{{'Incidencia'|translate}}</span> {{antecedent.description}}
                  </td>
                  <td><span class="p-column-title">{{'Fecha de Aprobación'| translate}}</span>
                    {{antecedent.agreementDate
                    | date: 'dd/MM/yyyy'}}</td>
                  <td class="text-right" *ngIf="!frameworkAgreement"><span class="p-column-title">{{'Presupuesto
                      (+IVA)'|
                      translate}}</span> {{antecedent.budget |
                    currency: 'EUR'}}</td>
                  <td class="text-right" *ngIf="!frameworkAgreement"><span class="p-column-title">{{'Precio (+IVA)'|
                      translate}}</span>
                    {{antecedent.price |
                    currency:
                    'EUR' }}</td>
                  <td class="text-right"><span class="p-column-title">{{'Plazo'| translate}}</span> {{antecedent.period}}</td>
                </tr>
              </ng-template>
            </p-table>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #antecedentPriceRevisionTableTemplate>
  <div class="row m-t-md " *ngIf="antecedents && antecedents.withPriceRevision">
    <div class="col-12 ">
      <div class="titleElement"> Incidencias de Revision de Precios Sin Gasto
      </div>
      <ng-container *ngIf="!antecedents || !antecedents.rvpAntecedents
          || antecedents.rvpAntecedents.length === 0; else dataExists">
        <div class="alert alert-info col-12" role="alert">
          <span style="line-height: 2em;">
            <i class="fa fa-1-5x fa-info-circle mr-2" aria-hidden="true"></i>
            {{ 'General.noData' | translate }}
          </span>
        </div>
      </ng-container>
      <ng-template #dataExists>
        <p-table [value]="antecedents.rvpAntecedents" [responsive]="false" class="col-12" dataKey="identifier"
          editMode="row">
          <!-- Contenido de la tabla -->

          <ng-template pTemplate="header">
            <tr>
              <th [style.width]="'50%'">{{'Incidencia'|translate}}</th>
              <th [style.width]="'50%'">{{'Fecha Fiscalización'| translate}}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-antecedent>
            <tr>
              <td><span class="p-column-title">{{'Incidencia'|translate}}</span> {{antecedent.description}}
              </td>
              <td><span class="p-column-title">{{'Fecha de Fiscalización'| translate}}</span>
                {{antecedent.agreementDate
                | date: 'dd/MM/yyyy'}}</td>
            </tr>
          </ng-template>
        </p-table>
      </ng-template>
    </div>
  </div>
</ng-template>

<ng-template #contractModificationAntecedentTableTemplate>
  <div class="row m-t-md ">
    <div class="col-12 ">
      <div class="row  ">
        <div class="col-12 ">

          <ng-container *ngIf="!antecedents || !antecedents.filterContractModificationAntecedents
          || antecedents.filterContractModificationAntecedents.length === 0; else dataExists">
            <div class="alert alert-info col-12" role="alert">
              <span style="line-height: 2em;">
                <i class="fa fa-1-5x fa-info-circle mr-2" aria-hidden="true"></i>
                {{ 'General.noData' | translate }}
              </span>
            </div>
          </ng-container>
          <ng-template #dataExists>
            <p-table [value]="antecedents.filterContractModificationAntecedents" [responsive]="false" class="col-12"
              dataKey="identifier" editMode="row">
              <!-- Contenido de la tabla -->

              <ng-template pTemplate="header">
                <tr>
                  <th [style.width]="'20%'">{{'Incidencia'|translate}}</th>
                  <th [style.width]="'30%'">{{'Fecha Aprobación'| translate}}</th>
                  <th class="text-right" *ngIf="!frameworkAgreement">{{'Presupuesto
                    (+IVA)'|translate}}</th>
                  <th class="text-right" *ngIf="!frameworkAgreement">{{'Precio (+IVA)'|
                    translate}}</th>
                  <th class="text-right">{{'Plazo (Meses)'| translate}}</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-antecedent>
                <tr>
                  <td><span class="p-column-title">{{'Incidencia'|translate}}</span> {{antecedent.description}}
                  </td>
                  <td><span class="p-column-title">{{'Fecha de Aprobación'| translate}}</span>
                    {{antecedent.agreementDate
                    | date: 'dd/MM/yyyy'}}</td>
                  <td class="text-right" *ngIf="!frameworkAgreement"><span class="p-column-title">{{'Presupuesto
                      (+IVA)'|
                      translate}}</span> {{antecedent.budget |
                    currency: 'EUR'}}</td>
                  <td class="text-right" *ngIf="!frameworkAgreement"><span class="p-column-title">{{'Precio (+IVA)'|
                      translate}}</span>
                    {{antecedent.price |
                    currency:
                    'EUR' }}</td>
                  <td class="text-right"><span class="p-column-title">{{'Precio (+IVA)'| translate}}</span>
                    {{antecedent.period }}</td>
                </tr>
              </ng-template>
            </p-table>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</ng-template>